module.exports = __webpack_public_path__ + "img/img_dianxin.c42c7d3b.png";